module.exports = __webpack_public_path__ + "front/img/29.302c5cfd.png";